class ArticleRelatedPosts extends TRYComponent {
  #track = null;
  #ac = null;

  connectedCallback() {
    this.#track = this.querySelector('[data-track]');
    if (!this.#track) return;

    this.#ac = new AbortController();
    const { signal } = this.#ac;

    swiperNav(
      this.#track,
      { prev: this.querySelector('[data-prev]'), next: this.querySelector('[data-next]') },
      signal,
    );
    dragScroll(this.#track, signal);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

customElements.define('article-related-posts', ArticleRelatedPosts);
